export default {
    details: 'You are not allowed to access this page.',
    goBack: 'Back to the last page',
    goHome: 'Go to home',
    title: 'Unauthorized.',
};
